import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/operation-card/";

export function getOperationDashboard(operationCardID = 0) {
  return http.get(apiEndpoint + "operation-dashboard/" + operationCardID);
}

export function getOperations() {
  return http.get(apiEndpoint + "operations");
}

export function searchOperations(warehouseID = 0) {
  return http.get(apiEndpoint + "search-operations/" + warehouseID);
}

export function saveOperationCard(operationCard) {
  return http.post(apiEndpoint + "save-operation-card", operationCard);
}

export function updateOperationCardStatus(operationCard, statusID) {
  operationCard.ID = parseInt(operationCard.id);
  operationCard.statusID = statusID;
  return http.post(apiEndpoint + "operation-card-status", operationCard);
}

export function getOperationItemTasks(
  operationCardID = 0,
  salesOrderItemID = 0
) {
  return http.get(
    `${apiEndpoint}operation-item-tasks/${operationCardID}/${salesOrderItemID}`
  );
}

export function getOperationStock(operationCardID = 0, salesOrderItemID = 0) {
  return http.get(
    `${apiEndpoint}operation-stock/${operationCardID}/${salesOrderItemID}`
  );
}

export function consumeOpItemsStock(consumeOpItemsStock) {
  return http.post(apiEndpoint + "consume-op-items-stock", consumeOpItemsStock);
}

export function unloadOpItemsStock(unloadOpItemsStock) {
  return http.post(apiEndpoint + "unload-op-items-stock", unloadOpItemsStock);
}
